// @flow
import React from 'react';
import { Modal, Button } from 'semantic-grab-ui/src';
import i18n from 'i18n-js';
import './exampleModal.scss';

type Props = {
  content?: any, // shows as a modal for example how it would look like in real life
};

export default class ExampleModal extends Modal {
  props: Props;

  render() {
    const { content } = this.props;

    if (content) {
      return (
        <Modal trigger={<Button basic>{i18n.t('rewards_page.form.example')}</Button>} className="example-image-modal">
          <Modal.Header>
            {i18n.t('rewards_page.form.example')}
          </Modal.Header>
          <Modal.Content>
            {content}
          </Modal.Content>
        </Modal>
      );
    }

    return null;
  }
}
